"use strict";

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _input = _interopRequireDefault(require("./input"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  max-width: 7.7rem;\n  cursor: pointer;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var QuantityBox = _styledComponents["default"].div(_templateObject());

var QuantityDropdown = function QuantityDropdown(props) {
  var hasInventory = props.hasInventory,
      selected = props.selected,
      disabled = props.disabled,
      maxNumber = props.maxNumber,
      onSelect = props.onSelect,
      _props$allowZeroValue = props.allowZeroValue,
      allowZeroValue = _props$allowZeroValue === void 0 ? true : _props$allowZeroValue,
      containerStyle = props.containerStyle,
      boxStyle = props.boxStyle;
  var options = Array.from({
    length: allowZeroValue ? maxNumber + 1 : maxNumber
  }, function (_, k) {
    if (!allowZeroValue) {
      return {
        id: k + 1,
        value: k + 1
      };
    } else return {
      id: k,
      value: k
    };
  });
  return /*#__PURE__*/_react["default"].createElement(QuantityBox, {
    style: boxStyle
  }, disabled ? /*#__PURE__*/_react["default"].createElement("div", {
    style: containerStyle
  }, /*#__PURE__*/_react["default"].createElement(_input["default"], {
    style: {
      cursor: "pointer"
    },
    isClearable: false,
    label: " ",
    labelTextProps: {
      padding: "0"
    },
    disabled: disabled,
    value: !hasInventory ? 0 : selected,
    options: null,
    onChange: function onChange(value) {
      return onSelect(value.value);
    },
    onClickOption: function onClickOption(value) {
      return onSelect(value.value);
    },
    backgroundColor: "#eee"
  })) : /*#__PURE__*/_react["default"].createElement("div", {
    style: containerStyle
  }, /*#__PURE__*/_react["default"].createElement(_input["default"], {
    style: {
      cursor: "pointer"
    },
    isClearable: false,
    label: " ",
    labelTextProps: {
      padding: "0"
    },
    value: !hasInventory ? 0 : selected,
    options: options,
    onChange: function onChange(value) {
      return onSelect(value.value);
    },
    onClickOption: function onClickOption(value) {
      return onSelect(value.value);
    }
  })));
};

var _default = QuantityDropdown;
exports["default"] = _default;
module.exports = exports["default"];